import styled from 'styled-components'

import { Font14, Font16 } from 'components/Typography'
import { WhiteBlock } from 'components/Layout'

export const TeamPermissionsBlockContainer = styled(WhiteBlock)`
  width: 100%;
  padding: 16px 16px 24px 16px;
  gap: 24px;
`
export const TeamBlockRow = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const TeamRightBlock = styled.div`
  display: flex;
  align-items: center;
`

export const TeamLeftBlock = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`

export const TeamUserBlock = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 16px;
`

export const TeamUserName = styled.div`
  word-break: break-word;
  font-weight: 900;
  ${Font16};
  margin-bottom: 4px;
`

export const TeamUserEmail = styled.div`
  word-break: break-word;
  ${Font14};
`

export const TeamPermissionsWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  gap: 16px;
`

export const TeamPermission = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-basis: 33.33%;
  gap: 16px;
`
export const TeamPermissionLabel = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  max-width: 101px;
  height: 32px;
  ${Font14};
`
